import React from 'react'

const DownloadAudio = () => {
  return (
    <div>DownloadAudio</div>
  )
}

export default DownloadAudio